// ***** RuleID / RuleName *****
const PREVIOUS_EMPLOYMENT_REVIEW_BREAKDOWN_RULE = 10;
const FRAUD_ALERT_EXISTS_RULE = 1;
const TWO_OR_MORE_MISSING_SCORES_RULE = 2;
const ACTIVE_DUTY_ALERT_EXISTS_RULES = 3;
const CREDIT_INQUIRY_WITHIN_90_DAYS_RULE = 4;
const DATE_OF_BIRTH_MISMATCH_RULE = 5;
const LESS_THAN_18_RULE = 6;
const MISSING_OR_INCORRECT_DOB_VALUE_RULE = 7;
const EXPIRATION_DATE_BEFORE_UPLOAD_DATE_RULE = 8;
const EXPIRATION_DATE_NOT_FOUND_RULE = 9;
const PAID_BY_OTHERS_ALERT_NON_MORTGAGE_DEBT_ROLE = 10;
const OPEN_MORTGAGE_PAYMENT_ALERT_RULE = 11;
const CALCULATION_REVIEW_BREAKDOWN = 21;
const MORTGAGE_HISTORY_PARENT_RULE = 29;
const FRAUD_ALERT_PARENT_RULE = 30;
const ACTIVE_DUTY_PARENT_RULE = 31;
const LIABILITY_ALL_ALERTS_RULE = 32;
const LIABILITY_PAYMENT_MISMATCH_ALERT_RULE = 33;
const LIABILITY_BALANCE_MISMATCH_ALERT_RULE = 34;
const LIABILITY_STUDENT_LOAN_PAYMENT_0_OR_NOT_REPORTED_FHA_RULE = 14057;
const LIABILITY_NO_PAYMENT_ALERT_RULE = 35;
const LIABILITY_MISSING_FROM_CREDIT_RULE = 37;
const LIABILITY_STUDENT_LOAN_DU = 39;
const LIABILITY_STUDENT_LOAN_LP = 40;
const LIABILITY_STUDENT_LOAN_FHA = 14029;
const LIABILITY_TYPE_MISMATCH_ALERT_RULE = 42;
const LIABILITY_VERIFY_ACCOUNTS_RULE = 14050;
const VA_LIABILITY_MORTGAGE_SEASONING_PARENT_RULE = 5012;
const VA_LIABILITY_MORTGAGE_HISTORY_PARENT_RULE = 5013;
const VA_LIABILITY_MORTGAGE_HISTORY_NO_DOCS_RULE = 5024;
const VA_LIABILITY_MORTGAGE_SEASONING_UNMODIFIED_RULE = 5014;
const VA_LIABILITY_MORTGAGE_SEASONING_MODIFIED_RULE = 5015;
const VA_LIABILITY_MORTGAGE_SEASONING_FORBEARANCE_RULE = 5016;
const PAYSTUB_NAME_MISMATCH = 25;
const PAYSTUB_ADDRESS_MISMATCH = 24;
const W2_NAME_MISMATCH = 27;
const W2_ADDRESS_MISMATCH = 26;
const RESIDENCY_STATUS_ALL_ALERTS_RULE = 16001;
const NON_PERMANENT_RESIDENT_RULE = 16003;
const PERMANENT_RESIDENT_RULE = 28;
const FOREIGN_NATIONAL_RULE = 16004;
const NON_PERMANENT_RESIDENCY_STATUS_FHA_RULE = 16005;
const FIRST_TIME_HOME_BUYER_DU_RULE = 38;
const FIRST_TIME_HOME_BUYER_LPA_RULE = 16002;
const BORROW_SMART_RULE = 16019;
const COMMUNITY_PROPERTY_STATE_RULE = 16006;
const COMMUNITY_PROPERTY_STATE_PER_BORROWER_RULE = 16007;
const TITLE_PACKAGE_REVIEW = 2000;
const TITLE_COMMITMENT_RULE = 2002;
const CPL_REVIEW_RULE = 2003;
const WIRE_INSTRUCTIONS_RULE = 2004;
const SELLER_ACQUISITION_RULE = 2005;
const LIABILITY_ASSOCIATE_ACCOUNTS_RULE = 22001;
const INCOME_SOURCE_RULE = 52;
const DOES_1040_SHOW_CONSISTENT_LOSS_RULE = 9058;
const FINAL_CHECKS_RULE = 21000;
const EMPLOYMENT_REVIEW_RULE = 17006;
const W2_SSN_MISMATCH = 17000;
const SCHEDULE_C_SSN_MISMATCH = 17001;
const FHA_SELF_EMPLOYMENT_MISSING_ADDRESS = 17034;
const WAGE_EARNER_MISSING_ADDRESS = 17035;
// TODO: update correct ids for Third party checks
const THIRD_PARTY_CHECKS_RULE = -103;
const MORTGAGE_LATE_PAYMENT_RULE = 14000;
const EARLY_CLOSING_DISCLOSURE_ALERT_RULE = 22000;
const REO_PAYMENT_ALERT_RULE = 14002;
const HELOC_ALERT_RULE = 14003;
const SSN_MISMATCH_ALL_ALERTS_RULE = 14004;
const BANKRUPTCY_DEROGATORY_RULE = 14005;
const FORECLOSURE_DEROGATORY_RULE = 14006;
const DEROGATORY_EVENTS_PARENT_RULE = 14007;
const JUDGEMENTS_DEROGATORY_RULE = 14008;
const COLLECTIONS_DEROGATORY_RULE = 14009;
const TAXLIEN_DEROGATORY_RULE = 14010;
const RECENTLY_PAID_OFF_DEBT_PARENT_RULE = 14012;
const REVOLVING_PAYMENT_ZERO_NOT_REPORTING_FHA_LP_RULE = 14100;
const REVOLVING_PAYMENT_ZERO_NOT_REPORTING_DU_RULE = 14104;
const NEW_DEBT_ON_CREDIT_INQUIRY_LETTER_RULE = 14054;
const CREDIT_REPORT_MANUAL_REVIEW = 14107;
const MORTGAGE_HISTORY_ALL_ALERTS_RULE_V2 = 14137;
const PENSION_SSN_RULE_ID = 9901;
const FHA_REQUIREMENTS = 62;
const INCOME_RECONCILIATION_RULE_ID = 4020;
const HOMEOWNERS_PARENT_RULE_ID = 10001;
const SUPPLEMENTAL_PARENT_RULE_ID = 10004;
const SUBJECT_PROPERTY_OCCUPANCY_FHA_CASHOUT_RULE_ID = 22003;
const FUTURE_INCOME_RULE_ID = 14;
const FINAL_REVIEW_RULE_ID = 21003;
const STATUS_AND_REVIEW_FLAG_RULE_ID = 21004;
const FLOOD_PARENT_RULE_ID = 10003;
const MASTER_INSURANCE_RULE_ID = 10002;
const NON_OCCUPYING_CO_BORROWER_RULE_ID = 16008;
const NEW_CONSTRUCTION_RULE_ID = 2007;

export const CITY_TAXES_REFERENCE_ID = '1005';
export const COUNTY_TAXES_REFERENCE_ID = '1006';
export const VILLAGE_TAXES_REFERENCE_ID = '1010';
export const MUD_TAXES_REFERENCE_ID = '1012';

export const RESIDENCYSTATUS = {
  FOREIGN_NATIONAL: 'ForeignNational',
  RESIDENT: 'Resident',
  NON_RESIDENT: 'Nonresident',
} as const;

const ASSET_RECONCILIATION_RULE_ID = 19998;
const TRANSFER_RECONCILIATION_RULE_ID = 19997;
const ASSET_TYPE_RULE_ID = 19000;
const ASSET_ACCOUNT_SUMMARY_RULE_ID = 19120;
const ASSET_BANK_STATEMENT_RULE_ID = 19110;
const ASSET_ACCOUNT_REVIEW_RULE_ID = 19130;
const ASSET_DEPOSIT_SOURCING_RULE_ID = 19131;
const PURCHASE_AGREEMENT_RULE_ID = 5301;
const PURCHASE_AGREEMENT_NO_DOCS_RULE_ID = 5302;
const NET_TANGIBLE_BENEFITS_RULE_ID = 13;
const NET_TANGIBLE_BENEFITS_VA_IRRRL_RULE_ID = 16020;
const VA_CAIVRS_NO_DOCS_RULE_ID = 16024;
const TAX_BREAKDOWN_RULE_ID = 22002;
const TAX_ESCROW_DETAILS_RULE_ID = 22008;
const TAX_SUMMARY_RULE_ID = 22010;
const TAX_BREAKDOWN_NO_DOCS_RULE_ID = 22042;
const APPRAISALS_RULE_ID = 22012;
const APPRAISALS_NO_DOCS_RULE_ID = 22013;
const APPRAISALS_SSR_RULE_ID = 22014;
const APPRAISALS_SUBJECT_PROPERTY_RULE_ID = 22015;
const APPRAISALS_SITE_RULE_ID = 22016;
const APPRAISALS_ENERGY_RULE_ID = 22017;
const APPRAISALS_DWELLING_EXTERIOR_RULE_ID = 22018;
const APPRAISALS_NO_UAD_RULE_ID = 22028;
const APPRAISALS_HIGHEST_AND_BEST_USE_RULE_ID = 22029;
const APPRAISALS_FUNCTIONAL_OBSOLESCENCE_RULE_ID = 22030;
const APPRAISALS_OUTBUILDING_RULE_ID = 22031;
const APPRAISALS_VEHICLE_STORAGE_RULE_ID = 22032;
const APPRAISALS_SUBJECT_PROPERTY_AMENITIES_RULE_ID = 22033;
const APPRAISALS_UNIT_INTERIOR_RULE_ID = 22019;
const APPRAISALS_CONDITION_QUALITY_RULE_ID = 22034;
const APPRAISALS_SKETCH_RULE_ID = 22020;
const APPRAISALS_MANUFACTURED_HOME_RULE_ID = 22021;
const APPRAISALS_PROJECT_INFORMATION_RULE_ID = 22035;
const APPRAISALS_SUBJECT_LISTING_INFO_RULE_ID = 22036;
const APPRAISALS_SUPPLEMENTAL_INFORMATION_RULE_ID = 22040;
const APPRAISALS_SALES_CONTRACT_RULE_ID = 22037;
const APPRAISALS_PRIOR_SALES_TRANSFER_HISTORY_RULE_ID = 22038;
const APPRAISALS_COST_APPROACH_RULE_ID = 22039;
const APPRAISALS_SALES_COMPARISON_APPROACH_RULE_ID = 22041;
const APPRAISALS_RECONCILIATION_RULE_ID = 22044;
const APPRAISALS_INCOME_APPROACH_RULE_ID = 22045;
const APPRAISALS_REMOVE_APPRAISAL_RULE_ID = 22046;
const APPRAISALS_MARKET_RULE_ID = 22047;
const APPRAISALS_RENTAL_INFORMATION_RULE_ID = 22050;
const APPRAISALS_FHA_REQUIREMENTS_RULE_ID = 22048;
const APPRAISALS_ALTERNATIVE_ELIGIBILITY_RULE_ID = 22049;
export const UNDERWRITER_FHA_RULE_ID = 30000;
export const FHA_UFMIP_REFUND_RULE_ID = 30001;
export const FHA_SECONDARY_FINANCING_RULE_ID = 30002;
const MISSING_PAYEE_RULE_ID = 22043;
const VA_LOAN_IDENTIFICATION_NUMBER_RULE_ID = 30004;
const VA_LOAN_IDENTIFICATION_NUMBER_NO_DOCS_RULE_ID = 30008;
const VA_OBLIGOR_RULE_ID = 30007;
const VA_OBLIGOR_NO_DOCS_RULE_ID = 30009;
const TITLE_SUMMARY_RULE_ID = 2006;
const VA_DOCUMENT_REVIEW_FORBEARANCE_REVIEW_RULE_ID = 30019;
const LIABILITIES_MORTGAGE_HISTORY_RULE_ID = 22004;
const VA_CAIVRS_RULE_ID = 30024;
const VA_DOCUMENT_REVIEW_NOTE_RULE_ID = 30012;
const VA_DOCUMENT_REVIEW_NOTE_NO_DOCS_RULE_ID = 30013;
const VA_DOCUMENT_REVIEW_CREDIT_REPORT_RULE_ID = 30010;
const VA_DOCUMENT_REVIEW_CREDIT_SUPPLEMENT_RULE_ID = 30016;
const VA_DOCUMENT_REVIEW_MORTGAGE_STATEMENT_RULE_ID = 30014;
const VA_DOCUMENT_REVIEW_PAYOFF_RULE_ID = 30011;
const VA_DOCUMENT_REVIEW_PAYOFF_STATEMENT_RULE_ID = 30015;
const VA_DOCUMENT_REVIEW_PAYOFF_STATEMENT_NO_DOCS_RULE_ID = 30020;
const VA_DOCUMENT_REVIEW_LOAN_MODIFICATION_AGREEMENT_RULE_ID = 30017;
const VA_DOCUMENT_REVIEW_LOAN_MODIFICATION_AGREEMENT_NO_DOCS_RULE_ID = 30018;

export const RULE_ID = {
  TITLE_PACKAGE_REVIEW,
  TITLE_COMMITMENT_RULE,
  CPL_REVIEW_RULE,
  WIRE_INSTRUCTIONS_RULE,
  SELLER_ACQUISITION_RULE,
  PREVIOUS_EMPLOYMENT_REVIEW_BREAKDOWN_RULE,
  FHA_REQUIREMENTS,
  FIRST_TIME_HOME_BUYER_LPA_RULE,
  FIRST_TIME_HOME_BUYER_DU_RULE,
  BORROW_SMART_RULE,
  PERMANENT_RESIDENT_RULE,
  NON_PERMANENT_RESIDENT_RULE,
  FOREIGN_NATIONAL_RULE,
  NON_PERMANENT_RESIDENCY_STATUS_FHA_RULE,
  RESIDENCY_STATUS_ALL_ALERTS_RULE,
  COMMUNITY_PROPERTY_STATE_RULE,
  COMMUNITY_PROPERTY_STATE_PER_BORROWER_RULE,
  FRAUD_ALERT_EXISTS_RULE,
  TWO_OR_MORE_MISSING_SCORES_RULE,
  ACTIVE_DUTY_ALERT_EXISTS_RULES,
  CREDIT_INQUIRY_WITHIN_90_DAYS_RULE,
  DATE_OF_BIRTH_MISMATCH_RULE,
  LESS_THAN_18_RULE,
  MISSING_OR_INCORRECT_DOB_VALUE_RULE,
  EXPIRATION_DATE_BEFORE_UPLOAD_DATE_RULE,
  EXPIRATION_DATE_NOT_FOUND_RULE,
  PAID_BY_OTHERS_ALERT_NON_MORTGAGE_DEBT_ROLE,
  OPEN_MORTGAGE_PAYMENT_ALERT_RULE,
  LIABILITY_ALL_ALERTS_RULE,
  LIABILITY_PAYMENT_MISMATCH_ALERT_RULE,
  LIABILITY_BALANCE_MISMATCH_ALERT_RULE,
  LIABILITY_STUDENT_LOAN_PAYMENT_0_OR_NOT_REPORTED_FHA_RULE,
  LIABILITY_NO_PAYMENT_ALERT_RULE,
  LIABILITY_MISSING_FROM_CREDIT_RULE,
  LIABILITY_STUDENT_LOAN_DU,
  LIABILITY_STUDENT_LOAN_LP,
  LIABILITY_STUDENT_LOAN_FHA,
  LIABILITY_TYPE_MISMATCH_ALERT_RULE,
  LIABILITY_VERIFY_ACCOUNTS_RULE,
  LIABILITY_ASSOCIATE_ACCOUNTS_RULE,
  VA_LIABILITY_MORTGAGE_SEASONING_PARENT_RULE,
  VA_LIABILITY_MORTGAGE_HISTORY_PARENT_RULE,
  VA_LIABILITY_MORTGAGE_HISTORY_NO_DOCS_RULE,
  VA_LIABILITY_MORTGAGE_SEASONING_UNMODIFIED_RULE,
  VA_LIABILITY_MORTGAGE_SEASONING_MODIFIED_RULE,
  VA_LIABILITY_MORTGAGE_SEASONING_FORBEARANCE_RULE,
  CALCULATION_REVIEW_BREAKDOWN,
  MORTGAGE_HISTORY_PARENT_RULE,
  MORTGAGE_HISTORY_ALL_ALERTS_RULE_V2,
  ACTIVE_DUTY_PARENT_RULE,
  FRAUD_ALERT_PARENT_RULE,
  PAYSTUB_NAME_MISMATCH,
  PAYSTUB_ADDRESS_MISMATCH,
  W2_NAME_MISMATCH,
  W2_ADDRESS_MISMATCH,
  INCOME_SOURCE_RULE,
  DOES_1040_SHOW_CONSISTENT_LOSS_RULE,
  FINAL_CHECKS_RULE,
  THIRD_PARTY_CHECKS_RULE,
  MORTGAGE_LATE_PAYMENT_RULE,
  EARLY_CLOSING_DISCLOSURE_ALERT_RULE,
  REO_PAYMENT_ALERT_RULE,
  HELOC_ALERT_RULE,
  SSN_MISMATCH_ALL_ALERTS_RULE,
  BANKRUPTCY_DEROGATORY_RULE,
  FORECLOSURE_DEROGATORY_RULE,
  DEROGATORY_EVENTS_PARENT_RULE,
  JUDGEMENTS_DEROGATORY_RULE,
  TAXLIEN_DEROGATORY_RULE,
  RECENTLY_PAID_OFF_DEBT_PARENT_RULE,
  REVOLVING_PAYMENT_ZERO_NOT_REPORTING_FHA_LP_RULE,
  REVOLVING_PAYMENT_ZERO_NOT_REPORTING_DU_RULE,
  COLLECTIONS_DEROGATORY_RULE,
  EMPLOYMENT_REVIEW_RULE,
  W2_SSN_MISMATCH,
  NEW_DEBT_ON_CREDIT_INQUIRY_LETTER_RULE,
  CREDIT_REPORT_MANUAL_REVIEW,
  SCHEDULE_C_SSN_MISMATCH,
  RESIDENCYSTATUS,
  PENSION_SSN_RULE_ID,
  ASSET_RECONCILIATION_RULE_ID,
  FHA_SELF_EMPLOYMENT_MISSING_ADDRESS,
  WAGE_EARNER_MISSING_ADDRESS,
  ASSET_TYPE_RULE_ID,
  INCOME_RECONCILIATION_RULE_ID,
  PURCHASE_AGREEMENT_RULE_ID,
  PURCHASE_AGREEMENT_NO_DOCS_RULE_ID,
  HOMEOWNERS_PARENT_RULE_ID,
  NET_TANGIBLE_BENEFITS_RULE_ID,
  NET_TANGIBLE_BENEFITS_VA_IRRRL_RULE_ID,
  ASSET_ACCOUNT_SUMMARY_RULE_ID,
  ASSET_BANK_STATEMENT_RULE_ID,
  ASSET_ACCOUNT_REVIEW_RULE_ID,
  ASSET_DEPOSIT_SOURCING_RULE_ID,
  TRANSFER_RECONCILIATION_RULE_ID,
  SUBJECT_PROPERTY_OCCUPANCY_FHA_CASHOUT_RULE_ID,
  FUTURE_INCOME_RULE_ID,
  FINAL_REVIEW_RULE_ID,
  STATUS_AND_REVIEW_FLAG_RULE_ID,
  TAX_BREAKDOWN_RULE_ID,
  TAX_ESCROW_DETAILS_RULE_ID,
  TAX_SUMMARY_RULE_ID,
  TAX_BREAKDOWN_NO_DOCS_RULE_ID,
  APPRAISALS_RULE_ID,
  APPRAISALS_NO_DOCS_RULE_ID,
  APPRAISALS_SSR_RULE_ID,
  APPRAISALS_SUBJECT_PROPERTY_RULE_ID,
  APPRAISALS_SITE_RULE_ID,
  APPRAISALS_ENERGY_RULE_ID,
  APPRAISALS_DWELLING_EXTERIOR_RULE_ID,
  APPRAISALS_NO_UAD_RULE_ID,
  APPRAISALS_HIGHEST_AND_BEST_USE_RULE_ID,
  APPRAISALS_CONDITION_QUALITY_RULE_ID,
  APPRAISALS_SKETCH_RULE_ID,
  APPRAISALS_UNIT_INTERIOR_RULE_ID,
  APPRAISALS_MANUFACTURED_HOME_RULE_ID,
  APPRAISALS_PROJECT_INFORMATION_RULE_ID,
  APPRAISALS_SUBJECT_LISTING_INFO_RULE_ID,
  APPRAISALS_FUNCTIONAL_OBSOLESCENCE_RULE_ID,
  APPRAISALS_OUTBUILDING_RULE_ID,
  APPRAISALS_VEHICLE_STORAGE_RULE_ID,
  APPRAISALS_SUBJECT_PROPERTY_AMENITIES_RULE_ID,
  APPRAISALS_SUPPLEMENTAL_INFORMATION_RULE_ID,
  APPRAISALS_SALES_CONTRACT_RULE_ID,
  APPRAISALS_PRIOR_SALES_TRANSFER_HISTORY_RULE_ID,
  APPRAISALS_COST_APPROACH_RULE_ID,
  APPRAISALS_SALES_COMPARISON_APPROACH_RULE_ID,
  APPRAISALS_RECONCILIATION_RULE_ID,
  APPRAISALS_INCOME_APPROACH_RULE_ID,
  APPRAISALS_REMOVE_APPRAISAL_RULE_ID,
  APPRAISALS_MARKET_RULE_ID,
  APPRAISALS_RENTAL_INFORMATION_RULE_ID,
  APPRAISALS_FHA_REQUIREMENTS_RULE_ID,
  APPRAISALS_ALTERNATIVE_ELIGIBILITY_RULE_ID,
  UNDERWRITER_FHA_RULE_ID,
  FHA_UFMIP_REFUND_RULE_ID,
  FHA_SECONDARY_FINANCING_RULE_ID,
  SUPPLEMENTAL_PARENT_RULE_ID,
  FLOOD_PARENT_RULE_ID,
  MASTER_INSURANCE_RULE_ID,
  NON_OCCUPYING_CO_BORROWER_RULE_ID,
  VA_LOAN_IDENTIFICATION_NUMBER_RULE_ID,
  VA_LOAN_IDENTIFICATION_NUMBER_NO_DOCS_RULE_ID,
  VA_OBLIGOR_RULE_ID,
  VA_OBLIGOR_NO_DOCS_RULE_ID,
  TITLE_SUMMARY_RULE_ID,
  MISSING_PAYEE_RULE_ID,
  LIABILITIES_MORTGAGE_HISTORY_RULE_ID,
  NEW_CONSTRUCTION_RULE_ID,
  VA_CAIVRS_RULE_ID,
  VA_DOCUMENT_REVIEW_NOTE_RULE_ID,
  VA_DOCUMENT_REVIEW_NOTE_NO_DOCS_RULE_ID,
  VA_DOCUMENT_REVIEW_CREDIT_REPORT_RULE_ID,
  VA_DOCUMENT_REVIEW_CREDIT_SUPPLEMENT_RULE_ID,
  VA_DOCUMENT_REVIEW_MORTGAGE_STATEMENT_RULE_ID,
  VA_DOCUMENT_REVIEW_FORBEARANCE_REVIEW_RULE_ID,
  VA_DOCUMENT_REVIEW_PAYOFF_RULE_ID,
  VA_DOCUMENT_REVIEW_PAYOFF_STATEMENT_RULE_ID,
  VA_DOCUMENT_REVIEW_PAYOFF_STATEMENT_NO_DOCS_RULE_ID,
  VA_DOCUMENT_REVIEW_LOAN_MODIFICATION_AGREEMENT_RULE_ID,
  VA_DOCUMENT_REVIEW_LOAN_MODIFICATION_AGREEMENT_NO_DOCS_RULE_ID,
  VA_CAIVRS_NO_DOCS_RULE_ID,
};

// ***** RuleCategoryID / RuleCategoryName *****
const CREDIT = 1;
const DOCUMENT = 2;
const DRIVERS_LICENSE = 3;
const INCOME = 4;
const LIABILITIES = 5;

export const RULE_CATEGORY_ID = {
  CREDIT,
  DOCUMENT,
  DRIVERS_LICENSE,
  INCOME,
  LIABILITIES,
};

export const CONDITION_CATEGORY = {
  INCOME: 15,
  DRIVERS_LICENSE: 16,
  CREDIT: 17,
  BORROWER: 18,
  PURCHASE_AGREEMENT: 19,
  EMPLOYMENT: 20,
  ASSETS: 21,
  LIABILITIES: 24,
  LOAN_FIRST: 0,
  PROCESSING: 1,
  COMPLIANCE: 2,
  CLOSING: 3,
  SUSPENSION: 4,
  FINAL_DOCS: 5,
  UNDERWRITING: 6,
  OFFSITE: 7,
  APPRAISAL_DELIVERY: 8,
  SETUP: 9,
  COUNTEROFFER: 10,
  TIE: 11,
  POST_CLOSING: 12,
  INVOICE: 13,
  FDQC: 14,
  HOMEOWNERS_INSURANCE: 22,
  PRELIMINARY_TITLE: 23,
  RENTAL_INCOME: 25,
  BROKER_VALIDATION: 26,
  PROPERTY: 27,
  MANUAL_CHECKS: 28,
  TITLE: 29,
  ALL_BOLT: 30,
  PROPERTY_TAXES: 31,
  RISK: 32,
  LOAN_CONDITIONS: -1,
};

// ***** RuleSubCategoryID / RuleSubCategoryName *****
// todo these don't match the db setup table?
const BORROWER = 1;
const DRIVERS_LICENSE_BORROWER = 2;
const CREDIT_LIABILITIES = 3;
const NET_TAGNIBLE_BENEFITS = 4;
const INCOME_CALCULATOR = 6;
export const RENTAL_INCOME = 12;
const PROPERTY_TAXES = 22;

export const RULE_SUB_CATEGORY_ID = {
  BORROWER,
  DRIVERS_LICENSE_BORROWER,
  CREDIT_LIABILITIES,
  NET_TAGNIBLE_BENEFITS,
  INCOME_CALCULATOR,
  PROPERTY_TAXES,
  UNDERWRITER_FHA: 25,
  CASE_NUMBER: 28,
};

// ***** RuleResultStatusID / RuleResultStatusName *****
const FIRED = 1;
const CLEARED = 2;
const DID_NOT_FIRE = 3;
const VERIFIED = 4;
const AUTOMATED_BOLT_SHIELD = 5;

export const RULE_RESULT_STATUS_ID = {
  FIRED,
  CLEARED,
  DID_NOT_FIRE,
  VERIFIED,
  AUTOMATED_BOLT_SHIELD,
} as const;

export const RuleResultStatuses = {
  fired: FIRED,
  cleared: CLEARED,
  verified: VERIFIED,
  automated: AUTOMATED_BOLT_SHIELD,
} as const;

// ** RuleReferenceType / RuleReferenceValue
const CREDIT_ALERT_ID = 1;
const BORROWER_POSITION = 2;
const INQUIRY_ID = 3;
const TRADELINE_ID = 4;
const LOAN_RECORD_ID = 5;
const CUSTOMER_RECORD_ID = 6;
const LICENSE_ID = 7;
const LENDER_DATABASE_ID = 8;
const DEBT_ID = 9;
const EMPLOYER_ID = 17;
const PAYMENT_HISTORY_ID = 18;
const DOCUMENT_ID = 21;
const ASSET_ID = 22;
const PUBLIC_RECORD_ID = 24;
const ADDRESS_ID = 23;
const CREDIT_REPORT_ALERT_ID = 26;
const CREDIT_REPORT_ALERT_SEQUENCE_NUMBER = 27;

export const RULE_REFERENCE_TYPE_ID = {
  CREDIT_ALERT_ID,
  BORROWER_POSITION,
  INQUIRY_ID,
  TRADELINE_ID,
  LOAN_RECORD_ID,
  CUSTOMER_RECORD_ID,
  LICENSE_ID,
  LENDER_DATABASE_ID,
  DEBT_ID,
  EMPLOYER_ID,
  PAYMENT_HISTORY_ID,
  DOCUMENT_ID,
  ASSET_ID,
  ADDRESS_ID,
  PUBLIC_RECORD_ID,
  CREDIT_REPORT_ALERT_ID,
  CREDIT_REPORT_ALERT_SEQUENCE_NUMBER,
};

export const RuleReferenceTypes = {
  creditAlert: CREDIT_ALERT_ID,
  borrowerPosition: BORROWER_POSITION,
  inquiry: INQUIRY_ID,
  tradeline: TRADELINE_ID,
  customer: CUSTOMER_RECORD_ID,
  debt: DEBT_ID,
  employer: EMPLOYER_ID,
  paymentHistory: PAYMENT_HISTORY_ID,
  document: DOCUMENT_ID,
  asset: ASSET_ID,
  address: ADDRESS_ID,
  publicRecord: PUBLIC_RECORD_ID,
  creditReportAlert: CREDIT_REPORT_ALERT_ID,
  creditReportAlertSequenceNumber: CREDIT_REPORT_ALERT_SEQUENCE_NUMBER,
} as const;

const UWM_ACTION_REQUIRED = 1;
const ERROR = 2;
const NO_ACTION_REQUIRED = 3;
const TIP = 4;
const PLAIN_TEXT = 5;
const MANUAL_REVIEW = 6;

export const ALERT_SEVERITY = {
  HINT: 0,
  WARNING: 1,
  ALERT: 2,
  SUCCESS: 3,
  ATTENTION: 4,
};

export const ALERT_STYLE = {
  UWM_ACTION_REQUIRED,
  ERROR,
  NO_ACTION_REQUIRED,
  TIP,
  PLAIN_TEXT,
  MANUAL_REVIEW,
} as const;

export const ALERT_STYLE_DESCRIPTION = {
  [ALERT_STYLE.UWM_ACTION_REQUIRED]: 'warning',
  [ALERT_STYLE.ERROR]: 'error',
  [ALERT_STYLE.NO_ACTION_REQUIRED]: 'success',
  [ALERT_STYLE.TIP]: 'info',
  [ALERT_STYLE.MANUAL_REVIEW]: 'extractionFailed',
};

const RENTAL_INCOME_CALCULATION_RULE_ID = 6;
const INCOME_REVIEW_BREAKDOWN_RULE_ID = 4;
const REVIEW_BREAKDOWN_YAML_RULE_ID = 10;

export const INCOME_RULE_ID = {
  RENTAL_INCOME_CALCULATION_RULE_ID,
  INCOME_REVIEW_BREAKDOWN_RULE_ID,
  REVIEW_BREAKDOWN_YAML_RULE_ID,
};

export const QUESTION_ID = {
  CPS_SPOUSE: 16006,
  VOB_LPA: 17017,
  VOB_DU: 17021,
  SCHEDULE_SE: 17039,
};

export const UNDERWRITING_METHODS = {
  DesktopUnderwriter: 1,
  LoanProductAdvisor: 2,
} as const;
